import React from "react";
import bgAppBanner from "../../../../Assets/Images/AppBanner.png";
import microsfot from "../../../../Assets/Images/microsfot.png";
import android from "../../../../Assets/Images/android.png";

export default function AppsSection() {
  return (
    <div id="appSection" className="AppsSection bg-white container py-5 pt0 pb0">
      <div className="row py-5 justify-content-between">
        <div className="col-lg-6">
          <div className="banner-inner">
            <p className="paragraph1 py-3 pb-2 fs-5 fw-bold">Apps</p>

            <h1 className="heading-xl fw-bold">
              Protect all your Devices
            </h1>
            <div className="">
              <div className="fs-6 py-2 d-flex text-body-secondary">
                Protect your Windows and Android. And you can secure
                up to 5 devices for the ultimate safeguard against any malicious
                threats.
              </div>
              <div className="donwloadBtn d-flex py-3">
                <img src={microsfot} alt="df" className="pe-4 img-fluid" />
                <img src={android} alt="df" className="img-fluid" />
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <img src={bgAppBanner} alt="ycf" className="img-fluid" />
        </div>
      </div>
    </div>
  );
}
